import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '../rootReducer';
import { IUnsubscribePreferenceState } from '../../types/unsubscribePreference/unsubscribePreference.types';

export const selectUnsubscribePreferenceState = (
  state: RootState
): IUnsubscribePreferenceState => state.unsubscribePreference;

export const selectUnsubscribeGroups = createSelector(
  [selectUnsubscribePreferenceState],
  (state) => state.unsubscribeGroups
);

export const selectUnsubscribePreferenceLoading = createSelector(
  [selectUnsubscribePreferenceState],
  (state) => state.loading
);

export const selectUnsubscribePreferenceError = createSelector(
  [selectUnsubscribePreferenceState],
  (state) => state.error
);

export const selectUnsubscribeGroupById = createSelector(
  [selectUnsubscribeGroups, (state: RootState, id: string) => id],
  (groups, id) => groups.find((group) => group._id === id)
);

export const selectPublicUnsubscribeGroups = createSelector(
  [selectUnsubscribeGroups],
  (groups) => groups.filter((group) => group.isPublic)
);

export const selectDefaultUnsubscribeGroups = createSelector(
  [selectUnsubscribeGroups],
  (groups) => groups.filter((group) => group.isDefault)
);

export const selectUnsubscribePreference = createSelector(
  [selectUnsubscribePreferenceState],
  (state) => state.preference
);

export const selectUnsubscribePreferenceSuccess = createSelector(
  [selectUnsubscribePreferenceState],
  (state) => state.success
);
